import React, { Component } from 'react';
import { Tooltip, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import find from 'lodash/find';
import QuestionnaireEditQuestionDrawer from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireEditQuestionDrawer';
import { TableData } from 'components/styled-components';
import { TableRow } from 'containers/Manage-Questionnaire/styled-components';

class Row extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, removeAnswer: false };
  }
  openDrawer = () => this.setState({ isOpen: true });
  closeDrawer = () => this.setState({ isOpen: false });
  handleDismissRemoveAnswer = () => this.setState({ removeAnswer: false });
  openRemoveAnswerDialog = () => this.setState({ removeAnswer: true });

  render() {
    const { question } = this.props;
    return (
      <TableRow>
        <TableData>{question.question}</TableData>
        <TableData>{question.controlID}</TableData>
        <TableData>
          {
            find(this.props.questionTypes, ['typeID', question.questionTypeID])
              .typeName
          }
        </TableData>
        <TableData>
          {
            find(this.props.categories, [
              'categoryID',
              question.displayCategoryID,
            ]).categoryName
          }
        </TableData>
        <TableData>{question.weight}</TableData>
        <TableData>
          {' '}
          <Tooltip content="Edit">
            <Icon
              icon={IconNames.EDIT}
              onClick={this.openDrawer}
              style={{ cursor: 'pointer' }}
            />
          </Tooltip>
        </TableData>
        <QuestionnaireEditQuestionDrawer
          isOpen={this.state.isOpen}
          isParentOpen={this.state.isOpen}
          openParen={this.openDrawer}
          closeDrawer={this.closeDrawer}
          question={question}
          mapping={true}
          {...this.props}
        />
      </TableRow>
    );
  }
}

export default Row;
